import { defineMessages } from 'react-intl';

export default defineMessages({
  creditContraAccount: {
    id: 'sentinel.components.transferPanel.creditContraAccount',
    defaultMessage: 'Contra Account',
  },
  creditType: {
    id: 'sentinel.components.transferPanel.creditType',
    defaultMessage: 'Credit Type',
  },
  accountSideDescription: {
    id: 'sentinel.components.transferPanel.accountSideDescription',
    defaultMessage: 'Account Description',
  },
  contraAccountSideDescription: {
    id: 'sentinel.components.transferPanel.contraAccountSideDescription',
    defaultMessage: 'Contra Account Description',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferPanelCreditDetails/messages.js